import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as EuFlag } from '../assets/flags/eu.svg';
import { ReactComponent as UsFlag } from '../assets/flags/us.svg';
import { RegionCode } from '../types';

const RegionFlag = ({ region }) => {
  switch (region) {
    case RegionCode.EU:
      return <EuFlag />;
    case RegionCode.US:
      return <UsFlag />;
    default:
      return <></>;
  }
};

RegionFlag.propTypes = {
  region: PropTypes.oneOf(Object.values(RegionCode)).isRequired,
};

export default RegionFlag;
